/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Avg_Speed_RangeInputs */

const en_exp_avg_speed_range = /** @type {(inputs: Exp_Avg_Speed_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recreational cycling: 20–25 km/h. Club riders: 25–32 km/h. Competitive: 32–40 km/h. Elite TT: 45+ km/h. Highly affected by terrain and wind.`)
};

const de_exp_avg_speed_range = /** @type {(inputs: Exp_Avg_Speed_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freizeit: 20–25 km/h. Verein: 25–32 km/h. Wettkampf: 32–40 km/h. Elite-Zeitfahren: 45+ km/h. Stark abhängig von Gelände und Wind.`)
};

/**
* | output |
* | --- |
* | "Recreational cycling: 20–25 km/h. Club riders: 25–32 km/h. Competitive: 32–40 km/h. Elite TT: 45+ km/h. Highly affected by terrain and wind." |
*
* @param {Exp_Avg_Speed_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_avg_speed_range = /** @type {((inputs?: Exp_Avg_Speed_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Avg_Speed_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_avg_speed_range(inputs)
	return de_exp_avg_speed_range(inputs)
});